import { render, staticRenderFns } from "./Single-choice-question.vue?vue&type=template&id=1db361f4"
import script from "./Single-choice-question.vue?vue&type=script&lang=js"
export * from "./Single-choice-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports